module.exports = __webpack_public_path__ + "static/media/10.2d99b5cb.png";